import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import theme from '../../theme';

// Summary
export const CardStyle = styled(Paper)(props => {
  const minHeight = props.size === 'large' || props.size ==='medium' ? '100%' : 'none';
  const maxHeight = props.size === 'large' || props.size ==='medium' ? '100%' : 'none';
  const marginBottom = props.size === 'large' || props.size ==='medium' ? 0 : '16px';

  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    textAlign: 'center',
    color: theme.palette.title.main,
    fontWeight: 600,
    minHeight: minHeight,
    maxHeight: maxHeight,
    marginBottom: marginBottom,
    padding: '16px',
    borderRadius: '8px',
    overflow: 'hidden',
  }
})

export const ColorSpan = styled('span')(props => {
  const color = props.color === "red" ? theme.palette.secondary.main : theme.palette.success.main;
  return {
    color: color
  }
})

//FilterSettings
export const FilterOutBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.grey.w200}`,
  width: '100%',
})